/*eslint-disable */
import React from 'react'
import { requestCreateCriterionC } from 'api/criterionC'
import { requestEcoRegionsSearch } from 'api/ecoRegions'
import CheckIcon from 'assets/icons/check-icon'
import Button from 'components/Button'
import Col from 'components/Col'
import Container from 'components/Container'
import Input from 'components/Input'
import MultiSelectionDropdown from 'components/MultiSelectDropdown'
import Row from 'components/Row'
import SearchDropdown from 'components/SearchDropdown'
import Textarea from 'components/Textarea'
import { defaultSiteProposalValidationResults } from 'constants/defaultSiteProposalValidationResults'
import { IrreversibleIndex, reasonDefaultOptions, reasonOptionsIrreversibleSelected, reasonOptionsReversibleSelected, ReversibleIndex } from 'constants/rejectTriggerReason'
import {
  requestUpdateCriterionCFiles,
  requestDeleteCriterionCFiles,
  requestGetCriterionCFiles,
} from 'api/site'
import Uploader from 'flow/SiteProposal/pages/About/uploader'
import UploadSiteFiles from 'components/SitesUploads'
import { showErrorToast } from 'utils/toast'

// Create criterion C-specific options for mutual exclusivity
const reasonQualifyOptions = [
  { label: 'Qualifies', value: 1, disabled: false },
  { label: 'Improved site information', value: 2, disabled: true },
  { label: 'KBA criteria revision', value: 3, disabled: true },
  { label: 'Revision to Red List status', value: 4, disabled: true },
  { label: 'Revision of global threshold', value: 5, disabled: true },
  { label: 'No longer geographically restricted', value: 6, disabled: true },
  { label: 'Genuine decline, irreversible', value: 7, disabled: true },
  { label: 'Genuine decline, reversible', value: 8, disabled: true },
  { label: 'Genuine decline, other factors', value: 9, disabled: true }
]

const reasonNonQualifyOptions = [
  { label: 'Qualifies', value: 1, disabled: true },
  { label: 'Improved site information', value: 2, disabled: false },
  { label: 'KBA criteria revision', value: 3, disabled: false },
  { label: 'Revision to Red List status', value: 4, disabled: false },
  { label: 'Revision of global threshold', value: 5, disabled: false },
  { label: 'No longer geographically restricted', value: 6, disabled: false },
  { label: 'Genuine decline, irreversible', value: 7, disabled: false },
  { label: 'Genuine decline, reversible', value: 8, disabled: false },
  { label: 'Genuine decline, other factors', value: 9, disabled: false }
]
import { 
  SITE_STATUS_DRAFT_ID, 
  SITE_STATUS_EDIT_ONLY_ID, 
  SITE_STATUS_SUBMITTED_EDIT_ONLY_ID,
  SITE_STATUS_CONFIRMED_ID,
  SITE_STATUS_PROPOSED_ID,
  SITE_STATUS_NOMINATED_ID,
  SITE_STATUS_REVIEWED_BY_RFP_ID,
  SITE_STATUS_SUPERSEDED_ID,
  SITE_STATUS_DELISTED_ID
} from 'constants/siteStatuses'
import { SiteContext } from 'providers/site'
import { useContext, useRef, useState, useEffect, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'
import capitalize from 'utils/capitalize'
import { delay } from 'utils/delay'
import isPositiveInteger from 'validators/isPositiveInteger'
import { EcosystemContentFooter } from '../EcosystemData/style'


const inputSaveDelayTime = 300
const updateEcoRegionQueryTimeOut = delay(inputSaveDelayTime)
const updateEcologicalIntegrityEcoRegionTimeOut = delay(inputSaveDelayTime)
const updateNumberOfCriterionSitesInEcoRegionTimeOut = delay(inputSaveDelayTime)
const updateEvidenceOfLowHumanImpactTimeOut = delay(inputSaveDelayTime)
const updateEvidenceForIntactEcologicalCommunitiesTimeOut = delay(inputSaveDelayTime)
const updateDateOfAssesmentTimeOut = delay(inputSaveDelayTime)
const updateTriggerReasonIdTimeOut = delay(inputSaveDelayTime)
const updateTriggerReasonTextTimeOut = delay(inputSaveDelayTime)

const accordionContent = ({ site, item: criterionC, updateCriterionC, siteId: propSiteId, toggleAccordion, defaultPage = false }) => {
  const params = useParams()
  const checkedValue = useRef([])
  const { siteProposalFieldValidation, isEditable } = useContext(SiteContext)
  const [checkedOptions, setCheckedOptions] = useState(reasonDefaultOptions)
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [isFilesLoading, setIsFilesLoading] = useState(false)

  // Derive siteId from props or site object - ensure it's a primitive value
  const rawSiteId = propSiteId || site?.id || site?.siteId || params?.siteId || params?.id
  const siteId = typeof rawSiteId === 'object' ? (rawSiteId?.id || rawSiteId?.siteId) : rawSiteId

  const editOnlySiteStatus = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
  const historyId = editOnlySiteStatus ? (site.sitehistoryId || params.siteHistoryId) : params.siteHistoryId
  const isReassessment = Boolean(historyId)
  const criterionCId = criterionC.site_ecointegrity_history_id || criterionC.site_ecointegrity_id

  // File helper functions
  function normFile(f) {
    const n = { ...f }
    n.id = n.id ?? n.file_id ?? null
    n.name = n.name ?? n.file_name ?? n.originalFilename ?? n.originalName ?? ""
    n.blob_name = n.blob_name ?? n.blobName ?? n.id ?? n.file_id ?? ""
    n.fileUrl = n.fileUrl ?? n.url ?? n.sasUrl ?? n.download_url ?? ""
    const blob = n.blob_name ?? n.blobName
    n.bareUrl = n.bareUrl ?? (blob ? `https://wdkbasitesfiles.blob.core.windows.net/sites-files/${blob}` : "")
    n.url = n.fileUrl || n.bareUrl || ""
    n.downloadUrl = n.fileUrl || n.url
    n.size = n.size ?? null
    n.mime = n.mime ?? n.mimetype ?? n.contentType ?? ""
    n.fileExtension = n.fileExtension ?? n.extension ?? null
    n.uploadedBy = n.uploadedBy ?? null
    return n
  }

  function uniqByKey(arr) {
    const seen = new Set()
    return (arr || []).filter((x) => {
      const n = normFile(x)
      const k = n.blob_name || n.url || n.id || ""
      if (seen.has(k)) return false
      seen.add(k)
      return true
    })
  }

  function extractFiles(res) {
    if (!res) return []
    if (Array.isArray(res)) return res
    if (Array.isArray(res.files)) return res.files
    if (Array.isArray(res.data?.files)) return res.data.files
    if (Array.isArray(res.data)) return res.data
    if (Array.isArray(res.results)) return res.results
    return []
  }

  // Load criterion C files
  useEffect(() => {
    async function loadCriterionCFiles() {
      if (!siteId || !criterionCId) return
      try {
        setIsFilesLoading(true)
        let res
        if (isReassessment) {
          res = await requestGetCriterionCFiles(siteId, historyId)
        } else {
          res = await requestGetCriterionCFiles(siteId)
        }

        const serverFiles = extractFiles(res).map(normFile)
        const merged = uniqByKey(serverFiles)
        setUploadedFiles(merged)
      } catch (error) {
        console.error('Failed to load criterion C files:', error)
      } finally {
        setIsFilesLoading(false)
      }
    }
    loadCriterionCFiles()
  }, [siteId, historyId, criterionCId, isReassessment])

  const uploaderFiles = useMemo(() => (uploadedFiles || []).map((f) => normFile(f)), [uploadedFiles])
  const uploaderParams = useMemo(() => ({ id: siteId, siteHistoryId: historyId }), [siteId, historyId])

  // Show uploader only when there's at least one criterion C (has an ID)
  const hasCriterionC = Boolean(criterionCId)

  const checkFields = siteProposalFieldValidation.criterionC[criterionC.site_ecointegrity_id || criterionC.site_ecointegrity_history_id] ?
    siteProposalFieldValidation.criterionC[criterionC.site_ecointegrity_id || criterionC.site_ecointegrity_history_id] :
    defaultSiteProposalValidationResults.criterionC
  
  function getSelectedSite(critC) {
    if (critC.EcoRegion && critC.EcoRegion.id) {
      return {
        label: critC.EcoRegion.name,
        value: critC.EcoRegion.id
      }
    }
    return null
  }
  const [ecoRegion, setEcoRegion] = useState(
    getSelectedSite(criterionC)
  )
  const [ecoRegionOptions, setEcoRegionOptions] = useState([])
  const [ecoRegionQuery, setEcoRegionQuery] = useState('')
  const [ecoRegionSite, setEcoRegionSite] = useState(criterionC.ecoregion_c_sites_count || '')
  const [ecoIntegrity, setEcoIntegrity] = useState(criterionC.evidence_low_human_impact || '')
  const [ecoIntegrity2, setEcoIntegrity2] = useState(criterionC.evidence_intact_ecology || '')
  const [year, setYear] = useState(criterionC.year || '')
  const [qualificationReason, setQualificationReason] = useState(criterionC.trigger_reason_id?.map((item) => {
      if (Number(item) > 3) {
        return Number(item) - 1
      }
      return Number(item)
    }))

  const [reassessmentRational, setReassessmentRational] = useState(criterionC.trigger_reason_text ? criterionC.trigger_reason_text : '')
  const qualified = criterionC.trigger_reason_id.some((element) => {
    // eslint-disable-next-line no-magic-numbers
    return Number(element) === 1
  }) || criterionC.trigger_reason_id.length === 0

  // Uploader visibility and editability:
  // - Visible in the assessment workflow only up to confirmation.
  // - Editable: Only in DRAFT (when editable) or during reassessment (EDIT_ONLY_ID, SUBMITTED_EDIT_ONLY_ID)
  // - Read-only: In other pre‑confirmation statuses.
  // - After confirmation (and later statuses), the uploader is hidden in this flow so
  //   ecological integrity uploads are not shown here for confirmed sites.
  const isEditableStatus = site.SiteStatusId === SITE_STATUS_DRAFT_ID || 
                          site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || 
                          site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
  const isConfirmedOrLater = site.SiteStatusId === SITE_STATUS_CONFIRMED_ID || 
                            site.SiteStatusId === SITE_STATUS_SUPERSEDED_ID || 
                            site.SiteStatusId === SITE_STATUS_DELISTED_ID
  const disabled = !isEditableStatus || (!isEditable && site.SiteStatusId === SITE_STATUS_DRAFT_ID) || !qualified
  const disabledQualificationReason = !isEditableStatus || (!isEditable && site.SiteStatusId === SITE_STATUS_DRAFT_ID)
  // Hide downloads together with the uploader after confirmation in this workflow
  const hideDownload = isConfirmedOrLater

  async function handleChangeValueChecked(Ids) {
      checkedValue.current = Ids
      const qualifyIndex = 0 // "Qualifies" is at index 0
      const isAnyNonQualifyOptionsSelected = Ids.some((item) => {
        return item.checked && item.value !== 1
      })

      if (Ids[IrreversibleIndex].checked) {
        setCheckedOptions(reasonOptionsIrreversibleSelected)
      } else if (Ids[ReversibleIndex].checked) {
        setCheckedOptions(reasonOptionsReversibleSelected)
      } else if (Ids[qualifyIndex].checked) {
        setCheckedOptions(reasonQualifyOptions)
      } else if (isAnyNonQualifyOptionsSelected) {
        setCheckedOptions(reasonNonQualifyOptions)
      } else {
        setCheckedOptions(reasonDefaultOptions)
      }
    }

  async function createAndUpdate(element) {
    const createdCriterionC = await requestCreateCriterionC(siteId, params.siteHistoryId)
    await updateCriterionC({ criterionCId: createdCriterionC.site_ecointegrity_history_id || createdCriterionC.site_ecointegrity_id, ...element })
  }

  function handleChangeEcoRegionQuery(e) {
    setEcoRegionQuery(e)

    if (e === '') {
      return
    }

    updateEcoRegionQueryTimeOut(() => {
      requestEcoRegionsSearch(e).then((data) => {
        setEcoRegionOptions(
          data.map((element) => {
            return { value: element.id, label: capitalize(element.name) }
          })
        )
      })
    })
  }

  async function handleChangeEcoRegion(e) {
    setEcoRegion(e)

    if (!criterionC.site_ecointegrity_id && !criterionC.site_ecointegrity_history_id) {
      return await createAndUpdate({ ecoregion_id: e.value })
    }

    updateEcologicalIntegrityEcoRegionTimeOut(async () => {
      await updateCriterionC({ criterionCId: criterionC.site_ecointegrity_history_id || criterionC.site_ecointegrity_id, ecoregion_id: e.value })
    })
  }


  async function handleChangeEcoRegionSite(e) {
    if (/^[0-9 ]*$/.test(e.target.value) || e.target.value === '') {
      setEcoRegionSite(e.target.value)
    }

    const numberOfCriterionSitesInEcoRegion = e.target.value ? Number(e.target.value) : null

    if (!criterionC.site_ecointegrity_id && !criterionC.site_ecointegrity_history_id) {
      return await createAndUpdate({ ecoregion_c_sites_count: numberOfCriterionSitesInEcoRegion })
    }

    if (isPositiveInteger(e.target.value) || e.target.value === '') {
      updateNumberOfCriterionSitesInEcoRegionTimeOut(async () => {
        await updateCriterionC({ criterionCId: criterionC.site_ecointegrity_history_id || criterionC.site_ecointegrity_id, ecoregion_c_sites_count: numberOfCriterionSitesInEcoRegion })
      })
    }
  }

  async function handleChangeEcoIntegrity(e) {
    setEcoIntegrity(e.target.value)

    if (!criterionC.site_ecointegrity_id && !criterionC.site_ecointegrity_history_id) {
      return await createAndUpdate({ evidence_low_human_impact: e.target.value })
    }

    updateEvidenceOfLowHumanImpactTimeOut(async () => {
      await updateCriterionC({ criterionCId: criterionC.site_ecointegrity_history_id || criterionC.site_ecointegrity_id, evidence_low_human_impact: e.target.value })
    })
  }

  async function handleChangeEcoIntegrity2(e) {
    setEcoIntegrity2(e.target.value)

    if (!criterionC.site_ecointegrity_id && !criterionC.site_ecointegrity_history_id) {
      return await createAndUpdate({ evidence_intact_ecology: e.target.value })
    }

    updateEvidenceForIntactEcologicalCommunitiesTimeOut(async () => {
      await updateCriterionC({ criterionCId: criterionC.site_ecointegrity_history_id || criterionC.site_ecointegrity_id, evidence_intact_ecology: e.target.value })
    })
  }

  async function handleChangeYear(e) {
    const currentYear = new Date().getFullYear()
    const passedValue = e.target.value
    // eslint-disable-next-line no-magic-numbers
    if (passedValue <= currentYear && !passedValue.includes('.') && !passedValue.includes(' ') && (passedValue > 0 || passedValue === '')) {
      setYear(passedValue)
    }
    // eslint-disable-next-line no-magic-numbers
    if (passedValue <= currentYear && passedValue > 1900 && passedValue.length === 4) {

      if (!criterionC.site_ecointegrity_id && !criterionC.site_ecointegrity_history_id) {
        return await createAndUpdate({ year: parseInt(e.target.value) || null })
      }

      updateDateOfAssesmentTimeOut(async () => {
        await updateCriterionC({ criterionCId: criterionC.site_ecointegrity_history_id || criterionC.site_ecointegrity_id, year: parseInt(e.target.value) || null })
      })
    }
  }

  async function handleChangeQualificationReason(e) {
    setQualificationReason(e)

    const formattedReasons = e.map((item) => {
      if (item > 3) {
        return item + 1
      }
      return item
    })

    const triggerReasonParams = formattedReasons.includes(1) ? { trigger_reason_id: formattedReasons } : { trigger_reason_id: formattedReasons, ecoregion_id: null }

    if (!criterionC.site_ecointegrity_id && !criterionC.site_ecointegrity_history_id) {
      return await createAndUpdate({ ...triggerReasonParams })
    }

    updateTriggerReasonIdTimeOut(async () => {
      await updateCriterionC({ criterionCId: criterionC.site_ecointegrity_history_id || criterionC.site_ecointegrity_id, ...triggerReasonParams })
    })

    if (formattedReasons.some(num => num > 1)) {
      setEcoRegion(null)
    }
  }

  async function handleChangeReassessmentRational(e) {
    setReassessmentRational(e.target.value)

    if (!criterionC.site_ecointegrity_id && !criterionC.site_ecointegrity_history_id) {
      return await createAndUpdate({ trigger_reason_text: e.target.value })
    }

    updateTriggerReasonTextTimeOut(async () => {
      await updateCriterionC({ criterionCId: criterionC.site_ecointegrity_history_id || criterionC.site_ecointegrity_id, trigger_reason_text: e.target.value })
    })
  }


  return (
    <Container width='100%' padding='0px'>
      <div data-testid='criterionC-form'>
        <Row>
          <Col md={6}>
            <SearchDropdown
              value={ecoRegion}
              onChange={handleChangeEcoRegion}
              options={ecoRegionQuery ? ecoRegionOptions : []}
              label='ecoRegion'
              field='ecoRegion'
              height='48px'
              iconTopPosition={checkFields.ecoregion_id ? '-68px' : '-95px'}
              placeholder='searchEcoRegionName'
              dataTest='search-dropdown'
              infoTooltip='ecoRegionHint'
              buttonIsPresent={false}
              indicatorSize='big'
              inputValue={ecoRegionQuery}
              onInputChange={handleChangeEcoRegionQuery}
              inputMargin='12px 0 12px 16px'
              disabled={disabled || !qualified}
              error={
                checkFields.ecoregion_id
                  ? { field: '', error: '' }
                  : {
                    field: 'ecoRegion',
                    error: 'pleaseCompleteThisField'
                  }
              }
              hyper={'https://www.keybiodiversityareas.org/working-with-kbas/programme/regional-focal-points'}
              shortLink={'www.keybiodiversityareas.org'}
            />
          </Col>
          <Col md={6}>
            <Input
              value={ecoRegionSite}
              onChange={handleChangeEcoRegionSite}
              infoTooltip='ecoRegionSiteHint'
              placeholder='enterNumberOfCriterionCSites'
              label='ecoRegionSite'
              field='numberOfCriterionSitesInEcoRegion'
              disabled={disabled || !qualified}
              error={
                checkFields.ecoregion_c_sites_count
                  ? { field: '', error: '' }
                  : {
                    field: 'numberOfCriterionSitesInEcoRegion',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} >
            <Textarea
              value={ecoIntegrity2}
              onChange={handleChangeEcoIntegrity2}
              label='ecoIntegrityEvidenceForIntact'
              field='evidenceForIntactEcologicalCommunities'
              infoTooltip='ecoIntegrityIntact'
              placeholder='enterEvidenceForIntactEcologicalCommunities'
              height='148px'
              disabled={disabled || !qualified}
              error={
                checkFields.evidence_intact_ecology
                  ? { field: '', error: '' }
                  : {
                    field: 'evidenceForIntactEcologicalCommunities',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
          <Col md={6} >
            <Textarea
              value={ecoIntegrity}
              onChange={handleChangeEcoIntegrity}
              label='ecoIntegrityLowHumanImpact'
              field='evidenceOfLowHumanImpact'
              infoTooltip='ecoIntegrityHuman'
              placeholder='enterEvidenceForLowHumanImpact'
              height='148px'
              disabled={disabled || !qualified}
              error={
                checkFields.evidence_low_human_impact
                  ? { field: '', error: '' }
                  : {
                    field: 'evidenceOfLowHumanImpact',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
        </Row>
        <Row>
          {(criterionC.last_reassessment_date !== null && site.reassessmentFlag && !defaultPage) && (
            <Col md={6}>
              <MultiSelectionDropdown
                value={qualificationReason}
                saveChanges={handleChangeQualificationReason}
                valueChecked={handleChangeValueChecked}
                label='triggerEcosystemLabel'
                infoTooltip='triggerLabelHint'
                field='qualificationReason'
                error={qualificationReason?.length === 0 ? {
                  field: 'qualificationReason',
                  error: 'pleaseCompleteThisField'
                } : { field: '', error: '' }}
                secondStepOptions={checkedOptions}
                placeholder='criterionCTriggerPlaceholder'
              />
            </Col>
          )}
          {(criterionC.last_reassessment_date !== null && site.reassessmentFlag && !defaultPage) && (
            <Col md={6}>
              <Textarea
                value={reassessmentRational}
                onChange={handleChangeReassessmentRational}
                placeholder='justificationNoChangeCriterionCPlaceholder'
                label='justificationNoChange'
                infoTooltip='qualificationReasonHint'
                field='rationalForReassessment'
                height='128px'
                disabled={disabledQualificationReason}
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col md={6}>
            <Input
              value={year}
              onChange={handleChangeYear}
              infoTooltip='assessmentDateHint'
              placeholder='assessmentDateEx'
              label='assessmentDate'
              field='dateOfAssesment'
              disabled={disabled || !qualified}
              error={
                checkFields.year
                  ? { field: '', error: '' }
                  : {
                    field: 'dateOfAssesment',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
        </Row>

        {hasCriterionC && !isConfirmedOrLater && (
          <Row>
            <Col md={12} style={{ marginTop: '32px', paddingTop: '24px', paddingBottom: '24px' }}>
              <UploadSiteFiles
                label="uploadCriterionCReport"
                field="uploadCriterionCReport"
                infoTooltip="criterionCUploaderHint"
                height="128px"
                dataTest="uploadCriterionCReport-text-area"
                isOptional={true}
                disabled={disabled || !qualified}
              />

              <div style={{ marginTop: '16px' }}>
                <Uploader
                  key={`criterionC-${siteId}-${historyId ?? "assessment"}-${uploadedFiles?.length}-${uploadedFiles
                    ?.map((f) => f.id || f.blob_name || f.file_name || f.name)
                    .join("|")}`}
                  params={uploaderParams}
                  siteFiles={uploaderFiles}
                  disabled={disabled || !qualified}
                  fileType="criterionC"
                  hideDownload={hideDownload}
                  fetchFilesFn={async (fetchSiteId, fetchSiteHistoryId) => {
                    try {
                      // Ensure siteId is a primitive value
                      const actualSiteId = typeof fetchSiteId === 'object' ? (fetchSiteId?.id || fetchSiteId?.siteId) : fetchSiteId
                      const actualHistoryId = typeof fetchSiteHistoryId === 'object' ? (fetchSiteHistoryId?.siteHistoryId || fetchSiteHistoryId?.historyId) : fetchSiteHistoryId
                      
                      let res
                      if (isReassessment) {
                        res = await requestGetCriterionCFiles(actualSiteId, actualHistoryId)
                      } else {
                        res = await requestGetCriterionCFiles(actualSiteId)
                      }
                      return res
                    } catch (error) {
                      console.error('Failed to fetch criterion C files:', error)
                      return { files: [] }
                    }
                  }}
                  uploadFn={async (uploadSiteId, uploadSiteHistoryId, formData, options) => {
                    try {
                      // Ensure siteId is a primitive value
                      const actualSiteId = typeof uploadSiteId === 'object' ? (uploadSiteId?.id || uploadSiteId?.siteId) : uploadSiteId
                      const actualHistoryId = typeof uploadSiteHistoryId === 'object' ? (uploadSiteHistoryId?.siteHistoryId || uploadSiteHistoryId?.historyId) : uploadSiteHistoryId
                      
                      const response = await requestUpdateCriterionCFiles(actualSiteId, actualHistoryId, formData, options)
                      
                      let nextFiles = extractFiles(response).map(normFile)
                      if (!nextFiles.length) {
                        let res
                        res = isReassessment
                          ? await requestGetCriterionCFiles(actualSiteId, historyId)
                          : await requestGetCriterionCFiles(actualSiteId)
                        nextFiles = extractFiles(res).map(normFile)
                      }
                      const merged = uniqByKey(nextFiles)
                      setUploadedFiles(merged)
                      return response
                    } catch (error) {
                      showErrorToast(<FormattedMessage id="uploadFailed" />)
                      throw error
                    }
                  }}
                  deleteFn={async (deleteSiteId, deleteSiteHistoryId, fileId) => {
                    try {
                      // Ensure siteId is a primitive value
                      const actualSiteId = typeof deleteSiteId === 'object' ? (deleteSiteId?.id || deleteSiteId?.siteId) : deleteSiteId
                      const actualHistoryId = typeof deleteSiteHistoryId === 'object' ? (deleteSiteHistoryId?.siteHistoryId || deleteSiteHistoryId?.historyId) : deleteSiteHistoryId
                      
                      const response = await requestDeleteCriterionCFiles(actualSiteId, actualHistoryId, fileId)
                      let nextFiles = extractFiles(response).map(normFile)
                      if (!nextFiles.length) {
                        let res
                        res = isReassessment
                          ? await requestGetCriterionCFiles(actualSiteId, historyId)
                          : await requestGetCriterionCFiles(actualSiteId)
                        nextFiles = extractFiles(res).map(normFile)
                      }
                      const merged = uniqByKey(nextFiles)
                      setUploadedFiles(merged)
                      return response
                    } catch (error) {
                      showErrorToast(<FormattedMessage id="deleteFailed" />)
                      throw error
                    }
                  }}
                />
              </div>
            </Col>
          </Row>
        )}

        {(criterionC.last_reassessment_date && site.SiteStatusId === SITE_STATUS_DRAFT_ID && !defaultPage) && (
          <Row>
            <Col md={12}>
              <EcosystemContentFooter>
                <Button height='40px' isDisabled={!criterionC.trigger_reason_id.length > 0} onClick={toggleAccordion}
                  type={criterionC.trigger_reason_id.length > 0 ? 'primary' : 'disabledPrimary'}>
                  <CheckIcon />
                  <FormattedMessage id='finishEditing' />
                </Button>
              </EcosystemContentFooter>
            </Col>
          </Row>
        )}
        {(!criterionC.last_reassessment_date && site.SiteStatusId === SITE_STATUS_DRAFT_ID && !defaultPage) && (
          <Row>
            <Col md={12}>
              <EcosystemContentFooter>
                <Button height='40px' onClick={toggleAccordion}
                  type='primary'>
                  <CheckIcon />
                  <FormattedMessage id='finishEditing' />
                </Button>
              </EcosystemContentFooter>
            </Col>
          </Row>
        )}
      </div>
    </Container>
  )
}

export default accordionContent
